<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.position.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.position.list.title"></app-i18n>
      </h1>

      <app-position-list-toolbar></app-position-list-toolbar>
      <app-position-list-filter></app-position-list-filter>
      <app-position-list-table></app-position-list-table>
    </div>
  </div>
</template>

<script>
import PositionListFilter from '@modules/position/components/position-list-filter.vue';
import PositionListTable from '@modules/position/components/position-list-table.vue';
import PositionListToolbar from '@modules/position/components/position-list-toolbar.vue';

export default {
  name: 'app-position-list-page',

  components: {
    [PositionListFilter.name]: PositionListFilter,
    [PositionListTable.name]: PositionListTable,
    [PositionListToolbar.name]: PositionListToolbar,
  },
};
</script>

<style>
</style>
